import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  successTimeOut = 5000;
  errorTimeOut = 15000;

  constructor(
    public snackBar: MatSnackBar,
    private zone: NgZone
  ) {}

  showSuccess(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, '×', {
        panelClass: ['success'],
        duration: this.successTimeOut,
        horizontalPosition: 'center'
      });
    });
  }

  showMultipleError(messages) {
    const message = messages.shift();
    let snackBarRef;
    if (message) {
      snackBarRef = this.snackBar.open(message, '×', {
        panelClass: ['error'],
        duration: this.errorTimeOut,
        horizontalPosition: 'center'
      });
      snackBarRef.afterDismissed().subscribe(() => {
        if (messages.length !== 0) {
          this.showMultipleError(messages);
        }
      });
    }
  }

  showError(message: string = 'Error'): void {
    this.zone.run(() => {
      this.snackBar.open(message, '×', {
        panelClass: ['error'],
        duration: this.errorTimeOut,
        horizontalPosition: 'center'
      });
    });
  }
}
